<div class="capitals">
  <div class="row">
    <div class="title-name">Emisora</div>
  </div>
  <div class="header-blotter">
    <div class="search" *ngIf="!isInPortfolio">
      <input
        #filter
        type="text"
        required
        [ngModel]="filterText"
        (ngModelChange)="filterData($event)"
        maxlength="15"
        (click)="$event.target.select()"
      />
      <label>Buscar una emisora</label>
    </div>

    <div
      *ngIf="showDownloadExcel"
      class="end-xs download-csv"
      (click)="generateExcel()"
      [ngClass]="pointerDisabled ? 'pointer-disabled' : ''"
    >
      Descargar excel
    </div>
  </div>

  <div class="table-blotter" *ngIf="!showSkeleton">
    <div class="scroll">
      <table>
        <thead>
          <tr>
            <td
              class="li-headers-format"
              *ngFor="let field of displayedColumns"
            >
              <div
                class="header-flex-container"
                *ngIf="field.sortable"
                (click)="setSortingProp(field.key)"
              >
                <span>{{ field.title }}</span>
                <div class="sort-icon"></div>
              </div>
              <div class="header-flex-container" *ngIf="!field.sortable">
                <span>{{ field.title }}</span>
              </div>
            </td>
            <td
              class="cancel-replace"
              *ngIf="showCancelButtons && !isUsaContract"
            ></td>
            <td class="cancel-replace" *ngIf="showCancelButtons"></td>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let c of orders; let odd = odd; let even = even"
            [ngClass]="{ odd: odd, even: even }"
          >
            <td class="li-text-format" *ngFor="let field of displayedColumns">
              <span
                *ngIf="field.key !== 'esStatus'"
                [attr.data-recording-sensitive]="field.sensitive || undefined"
                (click)="field.key === 'issueId' && preFillOperation(c.issueId)"
              >
                <ng-container
                  *ngIf="!(c[field.key] === undefined || c[field.key] === null)"
                >
                  {{
                    field.customFormat
                      ? (c[field.key]
                        | hbCustomFormat
                          : (field.customFormatLessThanOne && c[field.key] < 1
                              ? field.customFormatLessThanOne
                              : field.customFormat))
                      : c[field.key]
                  }}
                </ng-container>

                <span
                  class="skeleton"
                  *ngIf="
                    field.canBeSkeleton &&
                    (c[field.key] === undefined || c[field.key] === null)
                  "
                ></span>
              </span>
              <span
                *ngIf="field.key === 'esStatus'"
                class="o-status o-status--{{ c.icon }}"
                (mouseenter)="showTooltip($event, true)"
                (mouseleave)="hideTooltip($event)"
              >
                <div class="order-status order-status--{{ c.icon }}"></div>
                <span>{{ c[field.key] }}</span>
                <hb-tooltip-component
                  *ngIf="
                    c.status == tradingOrderStatus.rejected ||
                    c.status == tradingOrderStatus.executedWithErrors ||
                    c.status == tradingOrderStatusCustom.cancelRejectedAndFilled
                  "
                  class="fixed tooltip-message"
                  [isLarge]="true"
                  [style.top]="constTop + 'px'"
                  [style.left]="constLeft + 'px'"
                  [text]="
                    tooltipMessages[c.status][c.way]
                      ? tooltipMessages[c.status][c.way]
                      : tooltipMessages[c.status]
                  "
                  [relativePosition]="'left'"
                  [width]="288"
                >
                </hb-tooltip-component>
              </span>
            </td>

            <ng-container *ngIf="showCancelButtons && c.isCancelable">
              <td class="center-xs" *ngIf="!isUsaContract">
                <div
                  class="cancel-buttons"
                  *ngIf="c.isCancelable && !this.isInternalUser"
                >
                  <div class="cancel-cursor">
                    <div
                      class="stroke-more"
                      (click)="cancelAndReplace(c)"
                      (mouseenter)="showTooltip($event)"
                      (mouseleave)="hideTooltip($event)"
                    >
                      <i class="icon-replace icon-atm-icn-cancel-replace"></i>
                      <hb-tooltip-component
                        class="fixed tooltip-message"
                        [style.top]="constTop + 'px'"
                        [style.left]="constLeft + 'px'"
                        text="Reemplazar"
                        [relativePosition]="'left'"
                        [width]="100"
                      >
                      </hb-tooltip-component>
                    </div>
                  </div>
                </div>
              </td>
              <td class="center-xs">
                <div
                  class="cancel-buttons"
                  *ngIf="c.isCancelable && !this.isInternalUser"
                >
                  <div class="cancel-cursor">
                    <div
                      class="stroke-more-cancel"
                      (click)="cancel(c)"
                      (mouseenter)="showTooltip($event)"
                      (mouseleave)="hideTooltip($event)"
                    >
                      <i class="icon icon-notification-error"></i>
                      <hb-tooltip-component
                        class="fixed tooltip-message"
                        [style.top]="constTop + 'px'"
                        [style.left]="constLeft + 'px'"
                        text="Cancelar"
                        [relativePosition]="'left'"
                        [width]="80"
                        [hideTip]="true"
                        [hideShadow]="true"
                        theme="dark"
                      >
                      </hb-tooltip-component>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <div class="none-rows" *ngIf="totalRows === 0">
        <i class="icon icon-atm-icn-ordenes"></i>
        <div>Aún no tienes órdenes</div>
      </div>
    </div>
  </div>

  <div class="table-blotter" *ngIf="showSkeleton">
    <div class="scroll">
      <table>
        <thead>
          <tr>
            <td *ngFor="let field of displayedColumns">
              <span>{{ field.title }}</span>
              <div *ngIf="field.sortable" class="sort-icon"></div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of ordersEmptyState">
            <td *ngFor="let field of displayedColumns" class="li-text-format">
              <span class="skeleton"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="order-number" *ngIf="totalRows > 0">
    <span>{{ orders.length }} / {{ orders.length }} registros</span>
  </div>
</div>
<app-full-modal *ngIf="showModalCancelOrder" [hideActionButtons]="true">
  <div class="full-modal__title">Se envió tu solicitud de cancelación</div>
  <div class="full-modal__description">
    {{ cancellationMessage }}
  </div>

  <div class="full-modal__actions">
    <button
      type="button"
      (click)="handleToggleModal()"
      class="button button--big button--dark"
    >
      Entendido
    </button>
  </div>
</app-full-modal>
